// @flow
import styled from 'styled-components';

export const TableFlexCell = styled.div`
	display: flex;
	align-items: ${({ align }) => align || 'center'};
	justify-content: ${({ justify }) => justify || 'center'};
	min-width: ${({ width }) => width || 'auto'};
	position: ${({ position }) => position || 'static'};
	height: ${({ height }) => height || '100%'};
	flex-basis: ${({ basis, width }) => basis || width || 'auto'};
`;

export default TableFlexCell;


// WEBPACK FOOTER //
// ./src/components/Table/TableFlexCell.js